import { render, staticRenderFns } from "./PosCartList.vue?vue&type=template&id=611ffa76&scoped=true&"
import script from "./PosCartList.vue?vue&type=script&lang=js&"
export * from "./PosCartList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611ffa76",
  null
  
)

export default component.exports